import { render, staticRenderFns } from "./DocumentResources.vue?vue&type=template&id=6d893f42&scoped=true"
import script from "./DocumentResources.vue?vue&type=script&lang=js"
export * from "./DocumentResources.vue?vue&type=script&lang=js"
import style0 from "./DocumentResources.vue?vue&type=style&index=0&id=6d893f42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d893f42",
  null
  
)

export default component.exports